import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import IRMDView from './ManufacturingDomestic/View';

function InspectionView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [inspectionreporttype, setinspectionreporttype] = useState('');
  const [inspectionreportcategory, setinspectionreportcategory] = useState('');
  const [data, setData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}inspectionReport/findById/${id}`, {
          headers: authHeader(),
        });
        setData(response.data);
        setinspectionreporttype(response.data.inspectionreporttype);
        setinspectionreportcategory(response.data.inspectionreportcategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (inspectionreporttype === 'Manufacturing') {
      return <IRMDView />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}inspectionReport/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/irindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW REPORT</h6>
          <div>
            <strong>Type:</strong> {inspectionreporttype} | <strong>Category:</strong> {inspectionreportcategory}
          </div>
          <div className="view-buttons">
            {(inspectionreportcategory === "Domestic" || inspectionreportcategory === "International") && data?.status === "Open" && (
              <Link to={`/inspection-to-grn-convert/${id}`}>
                <button className="button-70">Convert To GRN</button>
              </Link>
            )}

            {data?.status === "Open" && data?.status !== "Cancelled" && (
              <Link to={`/irEdit/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}

            <Link to={`/irindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}
      </Card>
    </div>
  );
}

export default InspectionView;